var p = /* @__PURE__ */ ((e) => (e.payment = "payment", e.setup = "setup", e))(p || {});
export {
  p as IntentTypeEnum
};
